/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { RemoteUsbDevice } from "../../usb-remote";

export abstract class PathosisDevice {
   protected remoteUsb: RemoteUsbDevice = null;
   constructor(usb: RemoteUsbDevice) {
      this.remoteUsb = usb;
   }
   public abstract getDeviceDescriptor(): ArrayBuffer;
   public abstract handleUrbMessage(vUrb, packet, callback): boolean;
}
